module.exports = __webpack_public_path__ + "img/29.3.TP.aefe4e0e.png";